import * as request from './utils/requester';

export const getAll = (page) => request.get(`/invoice?page=${page}`);

export const getById = (id) => request.get(`/invoice/details/${id}`);

export const create = (data) => request.post('/invoice', data);

export const edit = (data) => request.put(`/invoice/${data._id}`, data);

export const del = (data) => request.del(`/invoice/${data._id}`);


export const getOption = (option) => request.get(`/invoice?option=${option}`);